export const infrastructureLines = {
  name: `infrastructureLines`,
  sql: `
    SELECT cartodb_id, the_geom_webmercator, mun, lyr_name, name, lyr_cat, haz_wf, haz_fld, haz_eq2, haz_eq1, haz_damg, haz_tsu, haz_ls, haz_lev, haz_slr, miles
    FROM solano_ci09_line_merge_x_hazard
  `,
  cartoCSS: `
    #layer {
      line-width: 1;
      line-color: ramp([lyr_name], (#8f8f8f, #f7ff00, #ff7700, #ee00ff, #ee00ff, #ee00ff, #000000, #CCC, ), ("Street", "Transmission Line", "NG Pipeline", "Levee", "Levee Flood Wall", "Levee XS", "Railroad", "Bus Route"), =);
    }
  `,
  featureOverColumns: [
    'mun',
    'lyr_name',
    'name',
    'lyr_cat',
    'haz_wf',
    'haz_fld',
    'haz_eq2',
    'haz_eq1',
    'haz_damg',
    'haz_tsu',
    'haz_ls',
    'haz_lev',
  ]
}

export const infrastructureLinesTypes = {
  name: `infrastructureLinesTypes`,
  type: 'Category',
  source: infrastructureLines.sql,
  field: 'lyr_name',
  options: {
    limit: 100,
    operation: 'SUM',
    operationColumn: 'miles'
  }
}

export const infrastructureLinesSum = {
  name: 'infrastructureLinesSum',
  type: 'Formula',
  source: infrastructureLines.sql,
  field: 'miles',
  options: {
    operation: 'SUM',
  }
}















